import Splide from '@splidejs/splide';
( function( app ) {
  const COMPONENT = {
    init: function() {
      $( '.shop-hero__splide' ).each( function( index, element ) {
        const slider = new Splide( $( element )[0], {
          type: 'loop',
          arrows: false,
          gap: '24px',
          drag: true,
          autoWidth: true,
          pagination: false,
        } );
        slider.on( 'overflow', function( isOverflow ) {
          slider.options = {
            drag: isOverflow,
            clones: isOverflow ? undefined : 0, // Toggle clones
          };
          if ( isOverflow ) {
            $( '.shop-hero__slider-bg' ).addClass( 'is-slider' );
          }
        } );
        slider.mount();
      } );
    },
    finalize: function() {
    },
  };

  app.registerComponent( 'shop-hero', COMPONENT );
} )( app );
